import React from "react";
// External
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useHistory } from "react-router-dom";
// Icons
import CloseIcon from "@mui/icons-material/CloseOutlined";
// Internal
import { handleTrack, resetHistory } from "../../historyUtil";
export default (function (_a) {
    var title = _a.title, openFullFilters = _a.openFullFilters, filterList = _a.filterList, onApply = _a.onApply, clearMobileParams = _a.clearMobileParams;
    var onClose = function () {
        clearMobileParams();
        openFullFilters();
    };
    var history = useHistory();
    var onClear = function () {
        clearMobileParams();
        handleTrack(history.location.pathname, "mobileClear");
    };
    var onClickApply = function () {
        resetHistory(history);
        onApply();
        openFullFilters();
        handleTrack(history.location.pathname, "onApply");
    };
    return (React.createElement(Dialog, { open: true, fullScreen: true },
        React.createElement(DialogTitle, null,
            React.createElement(Box, { display: "flex", flex: 1, justifyContent: "space-between", alignItems: "center" },
                React.createElement(Typography, { variant: "h2" }, title || "Filters"),
                React.createElement(IconButton, { size: "small", "aria-label": "close", onClick: onClose },
                    React.createElement(CloseIcon, null)))),
        React.createElement(DialogContent, { dividers: true }, filterList.map(function (_a) {
            var label = _a.label, component = _a.component;
            return (React.createElement(Box, { key: label, paddingY: 2 }, component));
        })),
        React.createElement(DialogActions, null,
            React.createElement(Box, { display: "flex", flex: 1, justifyContent: "space-between" },
                React.createElement(Button, { variant: "text", color: "primary", onClick: onClear }, "Reset"),
                React.createElement(Button, { variant: "contained", size: "large", color: "primary", onClick: onClickApply }, "APPLY")))));
});
//# sourceMappingURL=InnerDialog.js.map